import { Grid, styled } from "@mui/material";

export const Form = styled(Grid)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(0, 4),
}));
